import React, {createContext, useState} from "react";
import PMSQuickListServices from "../../services/pms_services/PMSQuickListServices";
import Notification from "../../components/common/Notification";

export const PMSQuickListContext = createContext("PMSQuickListContext");

const PMSQuickListContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [quickListItems, setQuickListItems] = useState([]);
    const [allQuickListItems, setAllQuickListItems] = useState([]);
    const [selectedQuickList, setSelectedQuickList] = useState(null);

    const handleError = (error) => {
        setLoading(false);
        let _error = "Something went wrong.";
        if (error.message === "Network Error") _error = error.message;
        if (error.response && error.response.data) _error = error.response.data.message;
        setErrorMsg(_error);
        Notification("error", "ERROR", `${_error}`);
        return false;
    };

    const getAllQuickLists = async (pharmacyId, params = {}) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSQuickListServices.getAllQuickLists(pharmacyId, params);
            if (Object.keys(params).length > 0) {
                setQuickListItems(res.data.content || []);
            } else {
                setAllQuickListItems(res.data.content || []);
            }
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const getQuickListById = async (id, pharmacyId) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSQuickListServices.getQuickListById(id, pharmacyId);
            setSelectedQuickList(res.data || null);
            setLoading(false);
            return res.data || null;
        } catch (error) {
            return handleError(error);
        }
    };

    const createQuickListItem = async (pharmacyId, type, data) => {
        try {
            setLoading(true);
            await PMSQuickListServices.createQuickListItem(pharmacyId, type, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Item added successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const updateQuickListItem = async (id, pharmacyId, data) => {
        try {
            setLoading(true);
            await PMSQuickListServices.updateQuickListItem(id, pharmacyId, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Item updated successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const deleteQuickListItem = async (id, pharmacyId) => {
        try {
            setLoading(true);
            await PMSQuickListServices.deleteQuickListItem(id, pharmacyId);
            setLoading(false);
            Notification("success", "SUCCESS", "Item deleted successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    return (
        <PMSQuickListContext.Provider
            value={{
                loading,
                errorMsg,
                quickListItems,
                allQuickListItems,
                selectedQuickList,
                getAllQuickLists,
                getQuickListById,
                createQuickListItem,
                updateQuickListItem,
                deleteQuickListItem,
            }}
        >
            {children}
        </PMSQuickListContext.Provider>
    );
};

export default PMSQuickListContextProvider;
